export const AppConsts = {
    env: {
        // `REACT_APP_API_BASE_URL` points the app at another server, e.g. a local Bolt REST server:
        // `REACT_APP_API_BASE_URL=http://localhost:3000/v1/ npm start`. Unset = the UAT server.
        remoteServiceBaseUrl: process.env.REACT_APP_API_BASE_URL
            || "https://evserveruat.optechain.com/v1/",
        gcp_key: process.env.REACT_APP_GCP_KEY || "AIzaSyCe0op8bR-aYLrsYptrC6aUW5TkWudIuPM",
        recaptchaSiteKey: "iZWPJyR27lB0cR4hL_xOX0GC"
    },
    theme: {
        colors: {
            green: "#4fc960"
        }
    }
};

export enum ChargePointStatus {
    AVAILABLE = "Available",
    OCCUPIED = "Occupied",
    CHARGING = "Charging",
    FAULTED = "Faulted",
    RESERVED = "Reserved",
    FINISHING = "Finishing",
    PREPARING = "Preparing",
    SUSPENDED_EVSE = "SuspendedEVSE",
    SUSPENDED_EV = "SuspendedEV",
    UNAVAILABLE = "Unavailable",
}
